import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

import {
  EXTRACTED_TABLES_BASE_QUERY_KEY,
  PART_BOT_RESULTS_BASE_QUERY_KEY,
  SUGGESTIONS_BASE_QUERY_KEY,
  TASK_STATUS_BASE_QUERY_KEY,
} from '@frontend/api';

/**
 * Refreshes various queries on the FileViewer page that have a staleTime associated with them.
 * This ensures when the page mounts we are getting fresh data even if the react query cache
 * staleTime window is still active.
 *
 * Currently handles the following queries:
 * - extracted_tables
 * - suggestions (field suggestions for quote setup)
 * - task_status (initial task status fetch per component)
 * - inferences (part bot results)
 *
 * NOTE: We need to do this because a staleTime is associated to these queries. Since the
 * query cache is not cleared when the page unmounts (i.e. navigating between pages) and only on
 * refresh, we need to manually invalidate the queries when the page mounts.
 */
export const useRefreshStaleQueriesOnMount = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries(EXTRACTED_TABLES_BASE_QUERY_KEY);
    queryClient.invalidateQueries(SUGGESTIONS_BASE_QUERY_KEY);
    queryClient.invalidateQueries(TASK_STATUS_BASE_QUERY_KEY);
    queryClient.invalidateQueries(PART_BOT_RESULTS_BASE_QUERY_KEY);
  }, [queryClient]);
};
